import { useMyTickets } from 'library/hooks/events';
import * as st from './styles.module.scss';

export const LeaveBtn = (): JSX.Element => {
  return <button className={st.wrapper}>Отказ от участия</button>;
};
